/* eslint-disable no-extend-native */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
import React, { useContext } from 'react'
import { UserContext } from "../context/userContext"
import { Link } from "react-router-dom"
import { signOut } from "firebase/auth"
import { useNavigate } from 'react-router-dom'
import { auth } from "../firebase"
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav'
import logoinvert from '../assets/icon-invert.png'
import { connect } from 'react-redux'
import { useCookies } from "react-cookie";

function NavbarWow(props) {
  const [cookie, setCookie, removeCookie] = useCookies(['whatson'], "/");
  const { toggleModals, currentUser } = useContext(UserContext) 

  const navigate = useNavigate()

  const logOut = async () => {
    try {
      console.log(props)
      await signOut(auth)
      removeCookie(["whatson"])
      props.setUserRole("")
      navigate("/")
    } catch (e) {
      console.log(e)
      alert("For some reasons we can't deconnect, please check your internet connection and retry.")
    }
  }

  const displaySignIn = (user) => {
    if(user !== undefined && user !== null){
      if(user.whatson !== undefined){
        if (user.whatson["role"] !== undefined) {
          return true;
        }
       }
    }
    return false;
  }

  const displayCreateVenue = (user) => {
    if(user !== undefined && user !== null){
      if(user.whatson !== undefined){
        if (user.whatson["role"] !== 0) {
          return true;
        }
       }
    }
    return false;
  }

  const overviewOrHome = (user) => {
    if(props.userRole === 1){
      return(<Nav.Link as={Link} to="/overview" className="kanit-medium">Home</Nav.Link>)
    }
    else{
      return(<Nav.Link as={Link} to="/" className="kanit-medium">Home</Nav.Link>)
    }
  }

  return (
    <Navbar bg="myColor" variant="light" sticky="top" style={{minHeight:85, boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.5)"}}>
      <Navbar.Brand href="/" ><img alt="Whats On Where" style={{maxHeight:80}} src={logoinvert}/></Navbar.Brand>
      V0.32
      <Nav className="ms-auto">
        {overviewOrHome(currentUser)}
        <Nav.Link hidden={!displaySignIn(cookie)}  as={Link} to='/create-event' className="kanit-medium">Create Event</Nav.Link>
        <Nav.Link hidden={!displayCreateVenue(cookie)}  as={Link} to='/create-venue' className="kanit-medium">Create Venue</Nav.Link>
        <Nav.Link hidden={displaySignIn(cookie)}  onClick={() => toggleModals("signIn")} className="kanit-medium">Sign In</Nav.Link>
        <Nav.Link hidden={!displaySignIn(cookie)} onClick={logOut} className="kanit-medium">Sign Out</Nav.Link>
      </Nav>
  </Navbar>
  )
}

export default connect(null, mapDispatchToProps)(NavbarWow);

function mapDispatchToProps(dispatch) {
  return {
      setUserRole: (e) => dispatch({
          type: 'SET_USERROLE',
          text: e
      })
  }
}